import React from "react";

import UnitSelectionView from "./UnitSelectionView";
import useUnitSelectionStep from "./useUnitSelectionStep";

const UnitSelectionStep = ({ onNext, onBack, setUnidadesSeleccionadas }) => {
  const selection = useUnitSelectionStep({ onNext, setUnidadesSeleccionadas });

  return (
    <UnitSelectionView
      {...selection}
      onBack={onBack}
      setCantidadUnidades={selection.handleCantidadUnidadesChange}
    />
  );
};

export default UnitSelectionStep;
